import './index.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import ConfigProvider from 'antd/es/config-provider'
import ru_RU from 'antd/locale/ru_RU'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'sonner'

import TestEnvironmentBadge from './components/TestEnvironmentBadge/TestEnvironmentBadge'
import ScreenSizeProvider from './providers/ScreenSizeProvider'
import { queryClient } from './utils/api/queryClient'
import { safeLazy } from './utils/app/safeLazy'
import {
  getFaviconByHost,
  getTitleByHost,
  isTestHost,
} from './utils/organisation/getLogoByHost'

const Router = safeLazy(() => import('./router-entry'))

const isMobile = () => window.innerWidth < 768

const initMetaTags = () => {
  document.title = getTitleByHost()

  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = getFaviconByHost()
}

initMetaTags()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <StrictMode>
  <QueryClientProvider client={queryClient}>
    <ScreenSizeProvider>
      {isTestHost() && <TestEnvironmentBadge />}
      <Toaster
        position={isMobile() ? 'top-center' : 'bottom-right'}
        richColors
        closeButton={isMobile() ? false : true}
        expand={false}
        visibleToasts={isMobile() ? 1 : 3}
        duration={isMobile() ? 1500 : 2500}
        theme="light"
        toastOptions={{
          style: {
            fontSize: '16px',
            padding: '20px',
            minHeight: '80px',
          },
          className: 'custom-toast',
        }}
      />
      <ConfigProvider
        locale={ru_RU}
        theme={{
          token: {
            fontFamily: 'Museo Sans Cyrl 300',
          },
        }}
      >
        <Suspense fallback={null}>
          <Router />
        </Suspense>
      </ConfigProvider>
    </ScreenSizeProvider>
    <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
  </QueryClientProvider>
  // </StrictMode>
)

// https://sonner.emilkowal.ski/ - Toaster
// https://sonner.emilkowal.ski/getting-started - Toaster Documentation
